// ABOUTME: Maps icon name strings from settings JSON to @ds/coolshop icon components.
// ABOUTME: Provides a finite lookup with a default fallback icon; names stay the config keys, the icons are the outlined twins.

import {
    AccountTreeOutlinedIcon,
    ArticleOutlinedIcon,
    AssessmentOutlinedIcon,
    BarChartOutlinedIcon,
    BuildOutlinedIcon,
    BusinessCenterOutlinedIcon,
    CategoryOutlinedIcon,
    CheckOutlinedIcon,
    CloudSyncOutlinedIcon,
    ContactsOutlinedIcon,
    DashboardOutlinedIcon,
    DescriptionOutlinedIcon,
    ExtensionOutlinedIcon,
    FolderOutlinedIcon,
    HandymanOutlinedIcon,
    ImageOutlinedIcon,
    InventoryOutlinedIcon,
    LanguageOutlinedIcon,
    LayersOutlinedIcon,
    ListOutlinedIcon,
    LocalOfferOutlinedIcon,
    MenuBookOutlinedIcon,
    PersonOutlinedIcon,
    PictureAsPdfOutlinedIcon,
    PrecisionManufacturingOutlinedIcon,
    ReceiptOutlinedIcon,
    SearchOutlinedIcon,
    SettingsOutlinedIcon,
    TranslateOutlinedIcon,
    VideoFileOutlinedIcon,
    ViewInArOutlinedIcon,
    WorkOutlinedIcon,
} from '@ds/coolshop';
import { ReactElement } from 'react';

const iconMap: Record<string, ReactElement> = {
    AccountTreeIcon: <AccountTreeOutlinedIcon />,
    ArticleIcon: <ArticleOutlinedIcon />,
    AssessmentIcon: <AssessmentOutlinedIcon />,
    BarChartIcon: <BarChartOutlinedIcon />,
    BuildIcon: <BuildOutlinedIcon />,
    BusinessCenterIcon: <BusinessCenterOutlinedIcon />,
    CategoryIcon: <CategoryOutlinedIcon />,
    CheckIcon: <CheckOutlinedIcon />,
    CloudSyncIcon: <CloudSyncOutlinedIcon />,
    DashboardIcon: <DashboardOutlinedIcon />,
    ContactsIcon: <ContactsOutlinedIcon />,
    DescriptionIcon: <DescriptionOutlinedIcon />,
    ExtensionIcon: <ExtensionOutlinedIcon />,
    FolderIcon: <FolderOutlinedIcon />,
    HandymanIcon: <HandymanOutlinedIcon />,
    ImageIcon: <ImageOutlinedIcon />,
    InventoryIcon: <InventoryOutlinedIcon />,
    LanguageIcon: <LanguageOutlinedIcon />,
    LayersIcon: <LayersOutlinedIcon />,
    ListIcon: <ListOutlinedIcon />,
    LocalOfferIcon: <LocalOfferOutlinedIcon />,
    MenuBookIcon: <MenuBookOutlinedIcon />,
    PersonIcon: <PersonOutlinedIcon />,
    PictureAsPdfIcon: <PictureAsPdfOutlinedIcon />,
    PrecisionManufacturingIcon: <PrecisionManufacturingOutlinedIcon />,
    ReceiptIcon: <ReceiptOutlinedIcon />,
    SearchIcon: <SearchOutlinedIcon />,
    SettingsIcon: <SettingsOutlinedIcon />,
    TranslateIcon: <TranslateOutlinedIcon />,
    VideoFileIcon: <VideoFileOutlinedIcon />,
    ViewInArIcon: <ViewInArOutlinedIcon />,
    WorkIcon: <WorkOutlinedIcon />,
};

const defaultIcon = <ListOutlinedIcon />;

export function resolveIcon(iconName?: string | null): ReactElement {
    if (!iconName) return defaultIcon;
    return iconMap[iconName] ?? defaultIcon;
}
